import { ChevronDown } from "react-feather";
import Select, { components } from 'react-select'
import SideBarSection from './SideBarSection';

const DropdownIndicator = (props) => (
	<components.DropdownIndicator {...props}>
		<ChevronDown
			size={18}
			className="dropdown-chevron"
			style={{
				transition: "transform 0.2s",
				transform: props.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
			}}
		/>
	</components.DropdownIndicator>
);

const TemplateSelector = ({ templates, selectedTemplate, setState, onUpdateTemplate, isSelection, className }) => {
	const chooseTemplate = (template) => {
		setState({ selectedTemplate: template }, () => onUpdateTemplate(isSelection, template));
	}
	return (
		<SideBarSection className={className}>
			<>
				<label className='label-input'>Template</label>
				<Select
					options={templates.map((template) => { return { value: template, label: template }})}
					className="search-select-field fund-selector"
					classNamePrefix="search-select-field"
					placeholder="Search"
					value={selectedTemplate ? { label: selectedTemplate, value: selectedTemplate } : null}
					components={{ IndicatorSeparator: () => null, DropdownIndicator }}
					blurInputOnSelect={true}
					onChange={(template) => chooseTemplate(template.value)}
					menuPosition="fixed"
					styles={{
						menuList: (provided) => ({
							...provided,
							maxHeight: "max(180px, calc(98vh - 472px))",
							overflowY: "auto",
						}),
						option: (provided, state) => ({
							...provided,
							padding: "0.75rem 0.5rem"
						})
					}}

				/>
			</>
		</SideBarSection>
	);
}

export default TemplateSelector;
